export default __webpack_public_path__ + "static/media/Version (2) - Prisoner of Azkaban_05.2f40f2ca.jpg";